"use client"

import { Suspense, useEffect, useState } from 'react'
import FloorPlansFilters from './floor-plans-filters'

interface FloorPlansPageWrapperProps {
  floorPlans: any[]
  children: React.ReactNode
}

function FloorPlansContent({ floorPlans, children, isScrolled }: FloorPlansPageWrapperProps & { isScrolled: boolean }) {
  return (
    <>
      <FloorPlansFilters floorPlans={floorPlans} isHeaderHidden={isScrolled} />
      {children}
    </>
  )
}

export default function FloorPlansPageWrapper({ floorPlans, children }: FloorPlansPageWrapperProps) {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 100
      setIsScrolled(scrolled)

      // Add or remove class to hide header
      const header = document.querySelector('header')
      if (header) {
        if (scrolled) {
          header.style.transform = 'translateY(-100%)'
          header.style.transition = 'transform 0.3s ease-in-out'
        } else {
          header.style.transform = 'translateY(0)'
          header.style.transition = 'transform 0.3s ease-in-out'
        }
      }
    }

    window.addEventListener('scroll', handleScroll)

    // Cleanup function to reset header when leaving page
    return () => {
      window.removeEventListener('scroll', handleScroll)
      const header = document.querySelector('header')
      if (header) {
        header.style.transform = 'translateY(0)'
        header.style.transition = ''
      }
    }
  }, [])

  return (
    <Suspense fallback={<div className="container mx-auto px-4 py-8">Loading filters...</div>}>
      <FloorPlansContent floorPlans={floorPlans} isScrolled={isScrolled}>
        {children}
      </FloorPlansContent>
    </Suspense>
  )
}